// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__25cXN","title":"InfoRow_title__1HUG9"};